<template>
<div class="component">
        <div class="tile is-child notification wwBackground">

    <div class="card ">
        <header class="card-header">
            <p class="projecttitle" >
                {{project["projectName"]}}
            </p>

        </header>
        <div class="card-content">
            <div class="content">
                {{project["description"]}}
            </div>
        </div>
        <footer class="card-footer">
            <a class="card-footer-item" @click="openProject()">Öffnen</a>
            <a class="card-footer-item" v-if="isProjectAdmin" @click="deleteProject(project.id)">Löschen</a>
        </footer>
    </div>
</div>
</div>
</template>

<script>
export default {
    name: 'projectOverview',
    props: ["project"],
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: []
        }
    },
    methods: {
        openProject() {
            this.$router.push({
                name: 'Project',
                params: {
                    id: this.project.id
                }
            })

        },
        deleteProject(projectid){
                let postData = {
                "projectId": projectid
            }
            this.callApi("/project/delete", "post", postData).then(function (response) {
                console.log("project deleted")
                this.refresh();
            }.bind(this))
        },
        refresh(){
            this.$emit("refresh");
        }
      
    },
    computed: {
        isProjectAdmin() {
            if (this.$store.getters.getUser != null && this.$store.getters.getUser != undefined && this.$store.getters.getUser != "") {
                return (this.$store.getters.getUser["id"] == this.project.projectManager_id)
            } else return false;

        },

    },
}
</script>

<style scoped>
.card-footer-item{
    border-top:1px solid rgba(1,1,1,0.2);
    border-right:1px solid rgba(1,1,1,0.2);
}
.notification {
    padding-right:1.5rem!important
}
.projecttitle{
    color: #363636;
    flex-grow: 1;
    font-weight: 700;
    border-bottom:1px solid rgba(1,1,1,0.2);
    padding: 0.75rem 1rem;}
</style>
